/**
 * Qual título mostrar na fila de curadoria, e em que idioma ele está.
 *
 * A mesma regra do catálogo (SPEC §9.2) — nunca título vazio, nunca fingindo
 * tradução — mas aqui ela pesa mais: a pessoa está decidindo o que publicar, e
 * um título em espanhol sem marca passaria por português mal escrito.
 *
 * Fica fora do componente para poder ser testado sem montar tela.
 */

import type { CurationItem, Locale } from './api';

/** O idioma do produto. O mesmo `PUBLICATION_LOCALE` do servidor. */
export const PUBLICATION_LOCALE: Locale = 'pt-BR';

export interface DisplayTitle {
  text: string;
  /** `null` só quando o exercício não tem tradução nenhuma. */
  locale: Locale | null;
  translated: boolean;
}

export function titleOf(item: CurationItem, preferred: Locale = PUBLICATION_LOCALE): DisplayTitle {
  const escolhido =
    item.translations.find((linha) => linha.locale === preferred) ??
    // Depois do idioma pedido vem o de origem, e não o primeiro da lista: é o
    // texto que alguém realmente escreveu para este exercício.
    item.translations.find((linha) => linha.locale === item.source_locale) ??
    item.translations[0];

  return {
    text: escolhido?.title ?? '',
    locale: escolhido?.locale ?? null,
    translated: escolhido?.locale === preferred,
  };
}
